import { useState, useCallback, useMemo, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Select } from '@linktivity/link-ui';
import { Tenant } from '@/services/types';
import { useStore } from '@/stores';
import styles from './header.module.css';

const SelectType = observer(() => {
  const navigate = useNavigate();
  const { tenantId } = useParams();
  const location = useLocation();
  const { tenants } = useStore();
  const [value, setValue] = useState(tenants.tenantId);

  useEffect(() => {
    setValue(tenants.tenantId);
  }, [tenants.tenantId]);

  const options = useMemo(
    () =>
      tenants.tenantGroups?.map(tenant => ({
        label: tenant.name as string,
        value: tenant.id as string
      })) || [],
    [tenants.tenantGroups]
  );

  const onSelect = useCallback(
    (value: string) => {
      setValue(value);
      tenants.setTenant(
        tenants.tenantGroups?.find(option => option.id === value) as Tenant
      );
      if (tenantId) {
        navigate(
          location.pathname.replace(`/${tenantId}`, value) + location.search
        );
      }
    },
    [location, navigate, tenants, tenantId]
  );

  return (
    <Select
      options={options}
      value={value}
      onSelect={onSelect}
      className={styles.select}
    />
  );
});

export default SelectType;
